<!--  -->
<template>
  <div class="add_box">
    <div class="search_box">
      <div style="display:flex;gap:10px;">
        <el-input v-model="objr.keywords" style="width:300px;" placeholder="请输入内容用户ID/企业ID/员工编号/员工名称" />
        <el-button type="primary" icon="el-icon-search" @click="sraw">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="awered">重置</el-button>
      </div>
      <div>
        <el-button type="primary" icon="el-icon-star-on" @click="accountfiter">账号过期筛选</el-button>
        <el-button type="success" icon="el-icon-plus" @click="addbit">激活账号</el-button>
      </div>
    </div>

    <!-- <el-button type="primary" @click="awered">重置</el-button> -->
    <el-table
      :data="tableData"
      border
      style="width: 100%;margin-top:20px"
    >
      <el-table-column
        prop="corp_name_inner"
        label="企业名称"
        width="280"
        align="center"
      />
      <el-table-column
        prop="corp_id"
        label="企业ID"
        width="300"
        align="center"
      />
      <el-table-column
        prop="user_id"
        label="用户ID"
        width="300"
        align="center"
      />
      <el-table-column
        prop="order_id"
        label="订单编号"
        width="300"
        align="center"
      />
      <el-table-column
        prop="name"
        label="员工名称"
        width="150"
        align="center"
      />
      <el-table-column
        prop="realName"
        label="创建人"
        width="100"
        align="center"
      />
      <el-table-column
        prop="type_text"
        label="账号类型"
        width="130"
        align="center"
      />
      <el-table-column
        prop="account_status"
        label="账号状态"
        width="130"
        align="center"
      />
      <el-table-column
        prop="extend_user_name"
        label="继承者"
        width="130"
        align="center"
      />
      <el-table-column
        prop="status_text"
        label="状态"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <div :class="{'':scope.row.status == 1,'activer':scope.row.status ==2}">{{ scope.row.status_text }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="expire_time_text"
        label="过期时间"
        width="160"
        align="center"
      >
        <template slot-scope="scope">
          <div :class="{'activer':scope.row.been_expire === true,'activerno':scope.row.been_expire === false}">{{ scope.row.expire_time_text }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="active_time_text"
        label="激活时间"
        width="160"
        align="center"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        width="160"
        align="center"
      />
      <el-table-column
        label="操作"
        width="100"
        fixed="right"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="transfer(scope.row)">账号继承</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="激活账号"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="40%"
    >
      <activation ref="activationview" @updata="updata" />
    </el-dialog>
    <el-dialog
      title="账号继承"
      :visible.sync="dialogtransfer"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="60%"
    >
      <transferAccnunyNumbrt ref="dialogtransfer" @updatatransfer="updatatransfer" />
    </el-dialog>
    <el-dialog
      title="账号过期筛选"
      :visible.sync="accountfifterdialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="60%"
    >
      <fifterdialog ref="fifterdialogview" @updatafifter="updatafifter" />
    </el-dialog>
    <pagination-right
      ref="paginationbox"
      :current-page="objr.page"
      :page-sizes="[10,20,30,50,100]"
      :total="newtotalr"
      @size-change="fetchPageSizer($event)"
      @current-change="fetchCurrentPager"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { userAccessList, transferAccount } from '@/api/officialaccount.js'
import activation from './components/activation.vue'
import transferAccnunyNumbrt from './components/transferAccnunyNumbrt.vue'
import fifterdialog from './components/fifterdialog.vue'

export default {
  components: {
    PaginationRight,
    activation,
    transferAccnunyNumbrt,
    fifterdialog
  },
  data() {
    return {
      dialogVisible: false,
      objr: {
        page: 1,
        page_size: 10,
        keywords: null
      },
      adtype: null,
      newtotalr: null,
      tableData: [],
      dialogtransfer: false,
      accountfifterdialog: false
    }
  },
  created() {
    this.menuList()
  },
  mounted() {

  },
  methods: {
    transfer(row) {
      this.dialogtransfer = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.dialogtransfer.sendr(row)
      }, 100)
    },
    async menuList() {
      // 获取列表
      const data = await userAccessList(this.objr)
      console.log('data', data)

      this.tableData = data.data.list
      this.newtotalr = data.data.total
    },
    sraw() {
      this.objr.page = 1
      // this.objr.page_size = 10
      this.menuList()
    },
    awered() {
      this.objr.page = 1
      // this.objr.page_size = 10
      this.objr.keywords = null
      this.menuList()
    },
    addbit() {
      this.dialogVisible = true
      // this.adtype = 1
      // setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
      //   this.$refs.activationview.send()
      // }, 100)
    },
    // 分页
    fetchPageSizer(e) {
      this.objr.page_size = e
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.menuList()
    },
    updata() {
      this.dialogVisible = false
      this.menuList()
    },
    async updatatransfer(arrs, corp_id, id) {
      // console.log('arrs, corp_id, id:-------', arrs, corp_id, id)
      await transferAccount({
        id,
        corp_id,
        user_id: arrs.map(v => v.user_id).join('')
      })
      this.dialogtransfer = false
      this.$message.success('继承成功')
      this.menuList()
    },
    accountfiter() {
      this.accountfifterdialog = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.fifterdialogview.send()
      }, 100)
    },
    updatafifter() {

    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box{
  padding: 20px;
}
.search_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.activer{
  color: red;
}
.activerno{
  color: #67C23A;
}
</style>
